import { ResetPasswordModel } from '.';

import { formatMessage } from 'src/api';
import MESSAGES from './../../../app/Pages/Home/Login/Login.messages';

export const resetPasswordFormData = (): ResetPasswordModel => ({
  email: {
    col: 12,
    defaultValue: undefined,
    disabled: false,
    error: false,
    errorMessage: formatMessage({...MESSAGES.loginErrorEmail}),
    label: formatMessage({...MESSAGES.loginLabelEmail}),
    name: 'email',
    type: 'email',
    placeholder: formatMessage({...MESSAGES.loginPlaceholderEmail}),
    required: true,
    validation: 'isEmail',
    value: '',
  }
});
